// extracted by mini-css-extract-plugin
export default {"wrap":"InspectionCard_wrap__jQrJ2","row":"InspectionCard_row__gbAQC","inspectionNotes":"InspectionCard_inspectionNotes__9FmK0"};